import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { jsx as _jsx } from "react/jsx-runtime";
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    width: 12,
    height: 14,
    fill: "none",
    viewBox: "0 0 12 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M11.688 9.766V1.234c0-.33-.28-.609-.61-.609H2.75A2.438 2.438 0 0 0 .312 3.063v8.124a2.438 2.438 0 0 0 2.438 2.438h8.328c.33 0 .61-.254.61-.61v-.406a.617.617 0 0 0-.229-.457c-.127-.406-.127-1.523 0-1.904a.628.628 0 0 0 .229-.482zM3.562 4.027c0-.076.051-.152.153-.152h5.383c.076 0 .152.076.152.152v.508c0 .102-.076.152-.152.152H3.715c-.102 0-.152-.05-.152-.152v-.508zm0 1.625c0-.076.051-.152.153-.152h5.383c.076 0 .152.076.152.152v.508c0 .102-.076.152-.152.152H3.715c-.102 0-.152-.05-.152-.152v-.508zM9.986 12H2.75a.802.802 0 0 1-.813-.813c0-.431.356-.812.813-.812h7.236a8.685 8.685 0 0 0 0 1.625z",
      fill: "#fff"
    })
  }));
};
export default SvgComponent;